import React from 'react'

const ResumenItem = ({speciality, year, place, works  }) => {
    return (
        <div className="resume-item">
            <h4>{speciality}</h4>
            <h5>{year}</h5>
            <p><em>{place}</em></p>
            <ul>
                {works.map((work, index) => <li key={index}>{work}</li>)}
            </ul>
        </div>
    )
}

export default ResumenItem